import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IVideoTutorial } from '@/shared/model/video-tutorial.model';

const apiUrl = 'api/tutorial-videos';

export default class VideoTutorialService {
  public findById(id: any): Promise<IVideoTutorial> {
    return new Promise<IVideoTutorial>((resolve, reject) => {
      axios
        .get(apiUrl + `/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retreive(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(apiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retreivePaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(apiUrl + `/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }


  public retrieveAllList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(apiUrl + `/all-list`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveAllListByUpperMenuId(id?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(apiUrl + `/by-upper-menu-id/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAllStatusList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(apiUrl + `/status/list`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAllContentTypeList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(apiUrl + `/content-type/list`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAllPermitTypeList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(apiUrl + `/permit-type/list`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IVideoTutorial): Promise<IVideoTutorial> {
    return new Promise<IVideoTutorial>((resolve, reject) => {
      axios
        .post(`${apiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }


  public update(entity: IVideoTutorial): Promise<IVideoTutorial> {
    return new Promise<IVideoTutorial>((resolve, reject) => {
      axios
        .put(apiUrl + `/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${apiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
